import { DataPointTreeBranchRES, DataPointTreeLeafRES } from 'src/pages/SignInPage/_BLL/types';

export const isDataPointTreeBranchRES = (leaf: DataPointTreeBranchRES | DataPointTreeLeafRES): leaf is DataPointTreeBranchRES => {
	return (leaf as DataPointTreeBranchRES).children !== undefined;
};
